// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-box {
  margin-top: 20px;
  margin-bottom: 20px;
}

.delivery-title {
  margin-left: 0px;
}

.gradiant-background {
  border: 1px solid #a0caca;
}

.basic-single-select {
  color: black;
}

.is-selected {
  color: red;
}

.is-focused {
  background-color: rgba(1, 198, 136, 0.15) !important;
}
.items .out-of-stock {
  background-color: lightpink;
}
h4.danger {
  color: crimson;
}
p.danger {
  color: crimson;
}

.single-quantity {
  background-color: #cae4e4;
  padding: 9px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 11px;
  border-radius: var(--bradius);
}

.cross-button {
  background-color: white;
  color: var(--mf-danger);
  padding-top: 5px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 7px;
  border-radius: var(--bradius);
  font-size: larger;
  cursor: pointer;
  border: 1px solid hsl(0, 0%, 80%);
}

.cross-button:hover {
  background-color: black;
  border-radius: var(--bradius);
}

/*toastr alert message*/
.address-toast {
  background-color: #6293a5;
}

.default-address-text {
  padding: 2px;
  border-radius: var(--bradius);
  background-color: #7eabfd;
  color: #fff;
  font-weight: normal;
  margin-left: 5px;
}

.alert-payment {
  margin-bottom: 50px;
}

.alert-billing-address {
  margin-top: 30px;
}

.address-switch-btn {
  color: #007bff;
  top: 10px;
  right: 10px;
  cursor: pointer;
  border: 1px solid #007bff;
  padding: 8px;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: var(--bradius);
  box-shadow:
    0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 0.3125rem 0 rgba(0, 0, 0, 0.12);
}

.address-switch-btn:hover {
  opacity: 0.8;
}

.custom-primary-btn {
  text-align: center;
  display: block;
  margin-left: 10px;
  margin-top: 0px;
  color: #007bff;
  cursor: pointer;
  border: 1px solid #a0caca;
  padding: 8px;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: var(--bradius);
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.custom-primary-btn:hover {
  background-color: #404040;
  opacity: 0.8;
}

.address-btn {
  float: left;
}

/* Shipping Rate Cards */
.shipping-rate-card.card {
  transition: all 0.2s ease-in-out;
  border: 2px solid #dee2e6;
  background-color: #fff;
}

.shipping-rate-card.card:hover {
  border-color: #01c688;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.shipping-rate-card-selected.card {
  background-color: rgba(1, 198, 136, 0.1) !important;
  border-color: #01c688 !important;
  box-shadow: 0 2px 4px rgba(1, 198, 136, 0.2) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Checkout/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oDAAoD;AACtD;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B;;;yCAGuC;AACzC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,gCAAgC;EAChC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;EACnD,gCAAgC;EAChC,uDAAuD;AACzD","sourcesContent":[".item-box {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.delivery-title {\n  margin-left: 0px;\n}\n\n.gradiant-background {\n  border: 1px solid #a0caca;\n}\n\n.basic-single-select {\n  color: black;\n}\n\n.is-selected {\n  color: red;\n}\n\n.is-focused {\n  background-color: rgba(1, 198, 136, 0.15) !important;\n}\n.items .out-of-stock {\n  background-color: lightpink;\n}\nh4.danger {\n  color: crimson;\n}\np.danger {\n  color: crimson;\n}\n\n.single-quantity {\n  background-color: #cae4e4;\n  padding: 9px;\n  padding-left: 15px;\n  padding-right: 15px;\n  padding-bottom: 11px;\n  border-radius: var(--bradius);\n}\n\n.cross-button {\n  background-color: white;\n  color: var(--mf-danger);\n  padding-top: 5px;\n  padding-left: 15px;\n  padding-right: 15px;\n  padding-bottom: 7px;\n  border-radius: var(--bradius);\n  font-size: larger;\n  cursor: pointer;\n  border: 1px solid hsl(0, 0%, 80%);\n}\n\n.cross-button:hover {\n  background-color: black;\n  border-radius: var(--bradius);\n}\n\n/*toastr alert message*/\n.address-toast {\n  background-color: #6293a5;\n}\n\n.default-address-text {\n  padding: 2px;\n  border-radius: var(--bradius);\n  background-color: #7eabfd;\n  color: #fff;\n  font-weight: normal;\n  margin-left: 5px;\n}\n\n.alert-payment {\n  margin-bottom: 50px;\n}\n\n.alert-billing-address {\n  margin-top: 30px;\n}\n\n.address-switch-btn {\n  color: #007bff;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n  border: 1px solid #007bff;\n  padding: 8px;\n  padding-left: 8px;\n  padding-right: 8px;\n  border-radius: var(--bradius);\n  box-shadow:\n    0 3px 1px -2px rgba(0, 0, 0, 0.2),\n    0 2px 2px 0 rgba(0, 0, 0, 0.14),\n    0 1px 0.3125rem 0 rgba(0, 0, 0, 0.12);\n}\n\n.address-switch-btn:hover {\n  opacity: 0.8;\n}\n\n.custom-primary-btn {\n  text-align: center;\n  display: block;\n  margin-left: 10px;\n  margin-top: 0px;\n  color: #007bff;\n  cursor: pointer;\n  border: 1px solid #a0caca;\n  padding: 8px;\n  padding-left: 5px;\n  padding-right: 5px;\n  border-radius: var(--bradius);\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n.custom-primary-btn:hover {\n  background-color: #404040;\n  opacity: 0.8;\n}\n\n.address-btn {\n  float: left;\n}\n\n/* Shipping Rate Cards */\n.shipping-rate-card.card {\n  transition: all 0.2s ease-in-out;\n  border: 2px solid #dee2e6;\n  background-color: #fff;\n}\n\n.shipping-rate-card.card:hover {\n  border-color: #01c688;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.shipping-rate-card-selected.card {\n  background-color: rgba(1, 198, 136, 0.1) !important;\n  border-color: #01c688 !important;\n  box-shadow: 0 2px 4px rgba(1, 198, 136, 0.2) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
